import type { PaletteOptions } from '@mui/material/styles';

// Exact values from the Figma HOME export (Dev Mode JSON), not eyeballed.
export const palette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#0d70ff', // VisionHeight blue — send, active nav, "+" (Figma DS: primary/main)
    contrastText: '#FFFFFF',
  },
  // Semantic colors — exact from Figma DS (Button color variants). MUI derives light/dark.
  secondary: { main: '#ff9f02', contrastText: 'rgba(0,0,0,0.87)' },
  error: { main: '#d32f2f', contrastText: '#FFFFFF' },
  warning: { main: '#ef6c00', contrastText: '#FFFFFF' },
  success: { main: '#2e7d32', contrastText: '#FFFFFF' },
  info: { main: '#0288d1', contrastText: '#FFFFFF' },
  text: {
    primary: '#00183E', // brand navy: headings, body, the greeting (Figma: text/primary)
    secondary: '#666564', // muted warm gray: labels, placeholders, sidebar (Figma: text/secondary)
    disabled: 'rgba(0,0,0,0.38)', // Figma: text/disabled (MUI default)
  },
  // The DS `<Divider> | Horizontal` renders `stroke="#7E7A76" opacity="0.12"` —
  // a WARM grey, not MUI's black-alpha default this was assumed to be. It sits on
  // the warm off-white canvas below, which is why. App-wide: every card border,
  // table rule and chip outline that reads `divider` moves with it.
  divider: 'rgba(126,122,118,0.12)', // Figma DS: divider (#7E7A76 @ 12%)
  background: {
    default: '#fcfbfa', // warm off-white canvas (Figma: background/primary)
    paper: '#FFFFFF', // white cards + prompt box (Figma: background/secondary)
    tertiary: '#faf9f8', // sidebar / drawer surface (Figma: background/tertiary)
    quaternary: '#f3f2f0', // the chat's own bubble (Figma: background/quaternary)
  },
  // IP risk scale (currentRisk 0/1/2). Whitelisted(-1) is deprecated. Used by
  // the intel card risk chip. Separate from semantic error/warning so the DS
  // owns the exact brand values.
  risk: {
    unrated: '#4EC2F5', // rgb(78,194,245) — currentRisk 0
    suspicious: '#ff9f02', // rgb(255,159,2) — currentRisk 1 (Figma DS amber/500)
    high: '#DC2626', // red — currentRisk 2
  },
  // Three DS surfaces with no MUI slot to live in. They were hex literals — two
  // inside the theme's own styleOverrides, one in WindowHeader under a comment
  // that said "no palette token (single use)". That is exactly how the input
  // radius drifted: the DS names a value, our theme doesn't carry it, so it gets
  // retyped wherever it is needed and nothing keeps the copies in step.
  surface: {
    chipFill: '#ececec', // Figma `_components/chip/defaultCloseFill` — default filled chip
    tooltip: '#eeedec', // the DS tooltip bubble (and its arrow)
    blue100: '#d3e5ff', // Figma blue/100 — the result panel's title backdrop
  },
  // action.* omitted on purpose — Figma uses MUI's default overlays exactly
  // (hover .04, selected .08, disabled .26, disabledBackground .12, active .54).
  // ponytail: no override = MUI defaults = Figma. Add back only if the DS diverges.
};
